var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _a, _RestrictedDatesHelper_loadedYears, _RestrictedDatesHelper_restrictedDates, _RestrictedDatesHelper_addRestrictedDate, _RestrictedDatesHelper_convertDate;
import { jsonapi } from "./jsonapi";
class RestrictedDatesHelper {
    static isDateRestricted(date, returnBoolean = false) {
        const restrictedDate = __classPrivateFieldGet(this, _a, "f", _RestrictedDatesHelper_restrictedDates).find(item => {
            return item.year === date.getFullYear()
                && item.month === date.getMonth() + 1
                && item.day === date.getDate();
        });
        if (returnBoolean) {
            return !!restrictedDate;
        }
        return restrictedDate ?? __classPrivateFieldGet(this, _a, "m", _RestrictedDatesHelper_convertDate).call(this, date, null, false);
    }
    static async loadRestrictedDatesByYear(year) {
        if (__classPrivateFieldGet(this, _a, "f", _RestrictedDatesHelper_loadedYears).includes(year)) {
            return Promise.reject();
        }
        __classPrivateFieldGet(this, _a, "f", _RestrictedDatesHelper_loadedYears).push(year);
        jsonapi.withPromises().request('holidays', { data: {
                'filter[year]': year
            } }).then((response) => {
            // Since PHP will return an empty object as an array,
            // we need to check
            if (Array.isArray(response)) {
                return;
            }
            for (const [date, data] of Object.entries(response)) {
                __classPrivateFieldGet(this, _a, "m", _RestrictedDatesHelper_addRestrictedDate).call(this, new Date(date), data.holiday, data.mandatory);
            }
        });
    }
    static removeRestrictedDate(date) {
        __classPrivateFieldSet(this, _a, __classPrivateFieldGet(this, _a, "f", _RestrictedDatesHelper_restrictedDates).filter(item => {
            return item.year !== date.getFullYear()
                || item.month !== date.getMonth() + 1
                || item.day !== date.getDate();
        }), "f", _RestrictedDatesHelper_restrictedDates);
    }
}
_a = RestrictedDatesHelper, _RestrictedDatesHelper_addRestrictedDate = function _RestrictedDatesHelper_addRestrictedDate(date, reason, lock = true) {
    const restricted = __classPrivateFieldGet(this, _a, "m", _RestrictedDatesHelper_convertDate).call(this, date, reason, lock);
    __classPrivateFieldSet(this, _a, __classPrivateFieldGet(this, _a, "f", _RestrictedDatesHelper_restrictedDates).filter(item => {
        return item.year !== restricted.year
            || item.month !== restricted.month
            || item.day !== restricted.day;
    }), "f", _RestrictedDatesHelper_restrictedDates);
    __classPrivateFieldGet(this, _a, "f", _RestrictedDatesHelper_restrictedDates).push(restricted);
}, _RestrictedDatesHelper_convertDate = function _RestrictedDatesHelper_convertDate(date, reason, lock) {
    return {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
        reason,
        lock
    };
};
_RestrictedDatesHelper_loadedYears = { value: [] };
_RestrictedDatesHelper_restrictedDates = { value: [] };
export default RestrictedDatesHelper;
